import type { Cell } from '@tanstack/react-table';
import { flexRender } from '@tanstack/react-table';
import cn from 'classnames';

import type { ColumnAlign } from '../lib/types';

type Props<TData> = {
  cell: Cell<TData, unknown>;
};

const alignmentClasses: Record<ColumnAlign, string> = {
  left: 'text-left',
  center: 'text-center',
  right: 'text-right',
};

export function BodyCell<TData>({ cell }: Props<TData>) {
  const align = cell.column.columnDef.meta?.align ?? 'left';

  return (
    <td
      className={cn(
        `
          px-2 py-3 align-middle typography-text-m text-primary
          lg:px-3 lg:py-4
        `,
        alignmentClasses[align]
      )}
    >
      {flexRender(cell.column.columnDef.cell, cell.getContext())}
    </td>
  );
}
